import BaseStore from '@/store/baseStore'
import { generateSingleItemOverview } from '@/store/baseOverview'

export const namespaced = true

const baseStore = new BaseStore('')
const baseOverview = generateSingleItemOverview({})

const getDefaultState = () => ({
  ...structuredClone(baseStore.state),
  ...structuredClone(baseOverview.state)
})

export const state = getDefaultState()

export const mutations = {
  ...baseStore.mutations,
  ...baseOverview.mutations,
  SET_OR_TOGGLE_LOADING(state, payload) {
    state.loading = payload === null ? !state.loading : payload
  }
}

export const actions = {
  ...baseStore.actions,
  ...baseOverview.actions,
  toggleLoading({ commit }, payload = null) {
    commit('SET_OR_TOGGLE_LOADING', payload)
  },
  async fetchOverviewData({ dispatch, rootState, state, commit }, stabSchematisationStage) {
    if (state.loadingMap[stabSchematisationStage.id] === true) {
      return
    }
    try {
      commit('TOGGLE_LOADING_OVERVIEW', stabSchematisationStage.id)
      if (state.itemsOverview.findIndex((id) => stabSchematisationStage.id === id) >= 0) {
        return
      }
      const rootOpt = { root: true }
      await dispatch('topoProfile/fetchItemOverview', stabSchematisationStage.topoprofile, rootOpt)
      await dispatch(
        'topoProfilePoint/fetchItemsOverview',
        stabSchematisationStage.topoprofile,
        rootOpt
      )
      if (stabSchematisationStage.soilcomposition) {
        await dispatch(
          'soilProfile/fetchItemsOverview',
          stabSchematisationStage.soilcomposition,
          rootOpt
        )
        await dispatch(
          'soilLayer/fetchItemsOverview',
          stabSchematisationStage.soilcomposition,
          rootOpt
        )
        await dispatch(
          'statePoints/fetchItemsOverview',
          stabSchematisationStage.soilcomposition,
          rootOpt
        )
      }
      if (stabSchematisationStage.latest_schematisation_stage_has_loads) {
        await dispatch(
          'treeLoads/fetchItemsOverview',
          stabSchematisationStage.latest_schematisation_stage_has_loads,
          rootOpt
        )
        await dispatch(
          'uniformLoads/fetchItemsOverview',
          stabSchematisationStage.latest_schematisation_stage_has_loads,
          rootOpt
        )
      }
      if (stabSchematisationStage.latest_schematisation_stage_has_phreatic_line) {
        const [multiplePhreaticLine] = await dispatch(
          'multiplePhreaticLine/fetchOverviewItem',
          stabSchematisationStage.latest_schematisation_stage_has_phreatic_line,
          rootOpt
        )
        await dispatch(
          'phreaticLine/fetchItemOverview',
          {
            id: multiplePhreaticLine.phreaticline,
            stabSchematisationStageId:
              stabSchematisationStage.latest_schematisation_stage_has_phreatic_line
          },
          rootOpt
        )
        await dispatch(
          'phreaticReferenceLine/fetchItemOverview',
          {
            id: multiplePhreaticLine.phreaticreferenceline,
            stabSchematisationStageId:
              stabSchematisationStage.latest_schematisation_stage_has_phreatic_line
          },
          rootOpt
        )
      }
      if (stabSchematisationStage.latest_schematisation_stage_has_head_line) {
        const multipleHeadLines = await dispatch(
          'multipleHeadLine/fetchOverviewItem',
          stabSchematisationStage.latest_schematisation_stage_has_head_line,
          rootOpt
        )
        for (const multipleHeadLine of multipleHeadLines) {
          await dispatch(
            'headLine/fetchItemOverview',
            {
              id: multipleHeadLine.headline,
              stabSchematisationStageId:
                stabSchematisationStage.latest_schematisation_stage_has_head_line,
              number: multipleHeadLine.number,
              enabled: multipleHeadLine.enabled
            },
            rootOpt
          )
          await dispatch(
            'headReferenceLine/fetchItemOverview',
            {
              id: multipleHeadLine.headreferenceline,
              stabSchematisationStageId:
                stabSchematisationStage.latest_schematisation_stage_has_head_line,
              number: multipleHeadLine.number,
              enabled: multipleHeadLine.enabled
            },
            rootOpt
          )
        }
      }
      if (stabSchematisationStage.stab_schematisation) {
        const stabSchematisation = rootState.stabSchematisation.items.find(
          (item) => item.id === stabSchematisationStage.stab_schematisation
        )
        if (stabSchematisation?.soil_type_revision) {
          await dispatch(
            'soilType/fetchItemsOverview',
            parseInt(stabSchematisation.soil_type_revision.id),
            rootOpt
          )
        }
      }
      commit('ADD_ITEM_OVERVIEW', stabSchematisationStage.id)
    } catch (e) {
      console.log(e)
    } finally {
      commit('TOGGLE_LOADING_OVERVIEW', stabSchematisationStage.id)
    }
  },
  cleanSchematisationStageRelatedData({ dispatch }, schematisationStage) {
    if (!schematisationStage) {
      return
    }
    dispatch('filterItemsOverview', (item) => item.id === schematisationStage.id)
    const rootOpt = { root: true }
    const topoProfileId = schematisationStage.topoprofile
    if (topoProfileId) {
      dispatch('topoProfile/filterItemsOverview', (item) => item.id !== topoProfileId, rootOpt)
      dispatch(
        'topoProfilePoint/filterItemsOverview',
        (item) => item.properties.topo_profile !== topoProfileId,
        rootOpt
      )
    }
    const soilCompositionId = schematisationStage.soilcomposition
    if (soilCompositionId) {
      dispatch(
        'soilProfile/filterItemsOverview',
        (item) => item.soil_composition !== soilCompositionId,
        rootOpt
      )
      dispatch(
        'soilLayer/filterItemsOverview',
        (item) => item.properties.soil_composition !== soilCompositionId,
        rootOpt
      )
      dispatch(
        'statePoints/filterItemsOverview',
        (item) => item.properties.soil_composition !== soilCompositionId,
        rootOpt
      )
    }
    const latestSchematisationStageIdHasLoads =
      schematisationStage.latest_schematisation_stage_has_loads
    if (latestSchematisationStageIdHasLoads) {
      dispatch(
        'treeLoads/filterItemsOverview',
        (item) => item.stage !== latestSchematisationStageIdHasLoads,
        rootOpt
      )
      dispatch(
        'uniformLoads/filterItemsOverview',
        (item) => item.stage !== latestSchematisationStageIdHasLoads,
        rootOpt
      )
    }
    const latestSchematisationStageIdHasPhreaticLine =
      schematisationStage.latest_schematisation_stage_has_phreatic_line
    if (latestSchematisationStageIdHasPhreaticLine) {
      dispatch(
        'phreaticLine/filterItemsOverview',
        (item) =>
          item.properties.stabSchematisationStageId != latestSchematisationStageIdHasPhreaticLine,
        rootOpt
      )
      dispatch(
        'phreaticReferenceLine/filterItemsOverview',
        (item) =>
          item.properties.stabSchematisationStageId != latestSchematisationStageIdHasPhreaticLine,
        rootOpt
      )
    }
    const latestSchematisationStageIdHasHeadLine =
      schematisationStage.latest_schematisation_stage_has_head_line
    if (latestSchematisationStageIdHasHeadLine) {
      dispatch(
        'headLine/filterItemsOverview',
        (item) =>
          item.properties.stabSchematisationStageId != latestSchematisationStageIdHasHeadLine,
        rootOpt
      )
      dispatch(
        'headReferenceLine/filterItemsOverview',
        (item) =>
          item.properties.stabSchematisationStageId != latestSchematisationStageIdHasHeadLine,
        rootOpt
      )
    }
  }
}

export const getters = {
  getLoadingById: baseOverview.getters.getLoadingById,
  getPlotData:
    (state, getters, rootState, rootGetters) =>
    (stabSchematisationStage = null) => {
      const lastestSchematisationHasLoads = stabSchematisationStage
        ? { id: stabSchematisationStage.latest_schematisation_stage_has_loads }
        : stabSchematisationStage
      const latestSchematisationStageIdHasPhreaticLine = stabSchematisationStage
        ? { id: stabSchematisationStage.latest_schematisation_stage_has_phreatic_line }
        : stabSchematisationStage
      const latestSchematisationStageIdHasHeadLine = stabSchematisationStage
        ? { id: stabSchematisationStage.latest_schematisation_stage_has_head_line }
        : stabSchematisationStage
      return [
        rootGetters['soilProfile/getPlotData'](stabSchematisationStage),
        rootGetters['soilLayer/getPlotData'](stabSchematisationStage),
        rootGetters['treeLoads/getPlotData'](lastestSchematisationHasLoads),
        rootGetters['uniformLoads/getPlotData'](lastestSchematisationHasLoads),
        rootGetters['statePoints/getPlotData'](stabSchematisationStage),
        rootGetters['topoProfilePoint/getPlotData'](stabSchematisationStage),
        rootGetters['phreaticLine/getPlotData'](latestSchematisationStageIdHasPhreaticLine),
        rootGetters['phreaticReferenceLine/getPlotData'](
          latestSchematisationStageIdHasPhreaticLine
        ),
        rootGetters['headLine/getMultiplePlotData'](latestSchematisationStageIdHasHeadLine),
        rootGetters['headReferenceLine/getMultiplePlotData'](latestSchematisationStageIdHasHeadLine)
      ].flat()
    }
}
